import React, { useEffect } from 'react';
import useUnifiedAnalytics from '../analytics/useUnifiedAnalytics';

const HomePage = () => {
  const analytics = useUnifiedAnalytics();
  
  // Track home page view
  useEffect(() => {
    analytics.trackPageView('home');
  }, [analytics]);
  return (
    <div className="min-h-screen bg-toon-yellow flex flex-col items-center justify-center p-4">
      <div className="text-center">
        <img 
          src="/assets/Toon_House_Logo.svg" 
          alt="Toon House Logo" 
          className="h-40 mx-auto mb-8"
        />
        <h1 className="text-4xl font-bold mb-4">Coming Soon</h1>
        <p className="text-xl mb-8">The future home of Toon House</p>
        
        <div className="mt-8">
          <a 
            href="/vote" 
            className="bg-black text-white py-3 px-6 rounded-full font-semibold hover:bg-gray-800 transition-colors"
          >
            Go to Voting
          </a>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
